const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered:  { opacity: 1 },
  exiting:  { opacity: 0, position: "absolute" },
  exited:  { opacity: 0, display: 'none' },
};

export {transitionStyles};
export {duration};
export {defaultStyle};
